import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import hero1 from '../assets/hero1.jpg'; 
import hero2 from '../assets/hero2.jpg';
import hero3 from '../assets/hero3.jpg';
import hero4 from '../assets/hero4.jpg';

const ImageCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: hero1,
      title: "Summer Collection 2024",
      subtitle: "Discover trending styles with up to 50% off",
      cta: "Shop Now"
    },
    {
      image: hero2,
      title: "Premium Electronics",
      subtitle: "Latest gadgets at unbeatable prices",
      cta: "Explore More"
    },
    {
      image: hero3,
      title: "Fashion Essentials",
      subtitle: "Style yourself with our exclusive collection",
      cta: "View Collection"
    },
    {
      image: hero4,
      title: "Special Offers",
      subtitle: "Limited time deals you can't resist",
      cta: "Get Deals"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="position-relative overflow-hidden" style={{ height: '60vh' }}>
      <AnimatePresence mode='wait'>
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="h-100 w-100"
        >
          <div 
            className="w-100 h-100 position-relative"
            style={{
              backgroundImage: `url(${slides[currentSlide].image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div 
              className="position-absolute w-100 h-100"
              style={{
                background: 'linear-gradient(45deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)',
                backdropFilter: 'blur(5px)'
              }}
            >
              <div className="container h-100">
                <div className="row h-100 align-items-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <motion.div
                      initial={{ y: 50, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: 0.2 }}
                      className="text-white p-4"
                    >
                      <h1 className="display-4 fw-bold mb-4">
                        {slides[currentSlide].title}
                      </h1>
                      <p className="lead mb-4">
                        {slides[currentSlide].subtitle}
                      </p>
                      <button className="btn btn-light btn-lg px-5 py-3 rounded-pill fw-bold">
                        {slides[currentSlide].cta}
                      </button>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Custom Navigation Dots */}
      <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4">
        <div className="d-flex gap-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`btn rounded-circle p-2 ${
                currentSlide === index ? 'btn-light' : 'btn-outline-light'
              }`}
              style={{
                width: '15px',
                height: '15px',
                padding: '0',
                border: '2px solid white'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;